import React, { useState, useEffect, useMemo} from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { 
  Calculator, 
  GraduationCap, // Para gestión académica
  ClipboardList, // Para un listado o historial
  CalendarDays, 
  CreditCard, 
  BookOpen,
  MenuIcon,
  X,
  LogOut,
} from 'lucide-react';
import { useAuth } from '../../metodos/AuthContext'; // Ajusta esta ruta según tu estructura
import logo from '../../assets/logo.png'; // Asegúrate de que la ruta sea correcta
import { useUsers } from '../../metodos/userContext';
import CompletarPerfilNuevoTutor from './Usuario/CompletarPerfil'; // Asegúrate de crear este componente
import PermisoInsuficiente from '../Logins/noPermisos'; // Asegúrate de crear este componente
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import CuentaInactiva from '../Logins/CuentaInactiva';

// Definimos las rutas de nuestra aplicación con iconos más relevantes
const routes = [
  { name: "Cotizar", icon: <Calculator size={20} />, path: "/dashboard" },
  { name: "Tesis Manager", icon: <GraduationCap size={20} />, path: "/tesis_manager", permission: '4. Realizacion de clases virtuales' },
  { name: "Mis Cotizaciones", icon: <ClipboardList size={20} />, path: "/historial_solicitudes" },
  { name: "Calendario", icon: <CalendarDays size={20} />, path: "/calendario" },
  { name: "Pagos", icon: <CreditCard size={20} />, path: "/pagos" },
  { name: "Recursos", icon: <BookOpen size={20} />, path: "/recursos" },
];

// Componente para el Sidebar
const Sidebar = ({routes, activeRoute, collapsed, setCollapsed, onNavigate, onLogout }) => {
  // Determinar si estamos en un dispositivo móvil
  const isMobile = window.innerWidth < 768;

  return (
    <div className={`bg-blue-800 text-white h-screen fixed transition-all duration-300 shadow-lg z-10
        ${collapsed ? 'w-16' : 'w-64'} 
        ${isMobile && collapsed ? '-translate-x-full' : 'translate-x-0'}`}>
      <div className="flex justify-between items-center p-4 border-b border-blue-700">
        
      {!collapsed && (
          <div className="flex justify-center items-center w-full py-4">
            <div className="login-logo">
              <img 
                src={logo} 
                alt="Logo de la aplicación" 
                className="max-w-[100%] mx-auto h-auto" 
                style={{ maxHeight: "500px" }}
              />
            </div>
          </div>
        )}

        <button
          className="p-1 rounded-md hover:bg-blue-700 focus:outline-none"
          onClick={() => setCollapsed(!collapsed)}
          aria-label={collapsed ? "Expandir menú" : "Colapsar menú"}
        >
          {collapsed ? <MenuIcon size={20} /> : <X size={20} />}
        </button>
      </div>

      <div className="overflow-y-auto h-[calc(100vh-64px)]">
        <nav className="mt-4">
          <ul>
            {routes.map((route) => (
              <li key={route.path} className="px-2">
                <button
                  className={`flex items-center w-full p-3 transition-colors
                    ${activeRoute === route.path
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-300 hover:bg-blue-700'
                    } 
                    ${collapsed ? 'justify-center' : 'justify-start'}`}
                  onClick={() => {
                    onNavigate(route.path);
                    if (isMobile) setCollapsed(true);
                  }}
                >
                  <span className="flex-shrink-0">{route.icon}</span>
                  {!collapsed && <span className="ml-3 whitespace-nowrap">{route.name}</span>}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div className="absolute bottom-0 w-full border-t border-blue-700 p-2">
          <button
            className={`flex items-center p-3 w-full text-gray-300 hover:bg-red-700 hover:text-white transition-colors
              ${collapsed ? 'justify-center' : 'justify-start'}`}
            onClick={onLogout}
          >
            <LogOut size={20} />
            {!collapsed && <span className="ml-3">Cerrar Sesión</span>}
          </button>
        </div>
      </div>
    </div>
    );
  };

// Componente de la barra superior para móviles
const MobileTopBar = ({ setCollapsed }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="md:hidden bg-blue-800 text-white p-3 sticky top-0 z-10 shadow-md flex justify-between items-center mobile-top-bar">
      <div className="flex items-center">
        <div className="bg-white p-1 rounded-md mr-2">
          <span className="text-blue-800 font-bold text-xs">EDU</span>
        </div>
        <div>
          <h1 className="font-bold">Portal de Tutores</h1>
          <div className="text-xs text-gray-300">EduSmart - v1.8.6</div>
        </div>
      </div>
      <div className="flex items-center space-x-3">
        <button 
          className="p-1"
          onClick={() => setCollapsed(false)}
        >
          <MenuIcon size={20} />
        </button>
        
      </div>
    </div>
  );
};

// Componente de la barra superior para escritorio
const DesktopTopBar = ({ userName , fotoPerfil }) => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="hidden md:flex items-center justify-between bg-white p-4 border-b border-gray-200">
      <div className="flex-1 max-w-xl">
        <div className="relative">
          <div>
            <h1 className="font-bold">Portal de Tutores</h1>
            <div className="text-xs text-gray-300">EduSmart - {process.env.REACT_APP_VERSION}</div>
          </div>
        </div>
      </div>
      
      <div className="flex items-center">

         {/* Barra de notificaciones 
        <div className="relative mr-4">
          <Bell size={20} className="text-gray-600" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
            3
          </span>
        </div>
        */}
        
        <div className="relative">
        <button
          onClick={() => setShowMenu(!showMenu)}
          className="flex items-center focus:outline-none"
        >
          {fotoPerfil && fotoPerfil !== "Foto perfil" ? (
            <img
              src={fotoPerfil}
              alt="Foto de perfil"
              className="w-8 h-8 rounded-full object-cover mr-2 border border-gray-300"
            />
          ) : (
            <div className="bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
              <span className="font-medium text-sm">JP</span>
            </div>
          )}
          <span className="text-gray-700">{userName}</span>
        </button>

      {/* Menú desplegable */}
      {showMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white border rounded-md shadow-lg z-50">
          <button
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            onClick={() => {
              setShowMenu(false);
              navigate('/dashboard/perfil')
            }}
          >
            Perfil
          </button>

          {/* Menú desplegable 
          <button
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            onClick={() => {
              setShowMenu(false);
              // Aquí podrías añadir otras configuraciones
            }}
          >
            Configuración
          </button>
          */}

        </div>
      )}
    </div>


      </div>
    </div>
  );
};

// Componente principal que integra todo
const HomeScreenTutor = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(window.innerWidth < 768);
  const [activeRoute, setActiveRoute] = useState('/solicitudes/disponibles');
  const navigate = useNavigate();
  const {logout } = useAuth();
  
  const { usuario ,loadingUsuario, errorUsuario} = useUsers();
  const {configuracion,loadingConfiguracion} = useConfiguracion();

  //filtrado de rutas
  const filteredRoutes = useMemo(() => {
    console.log("🚀 Inicia el cálculo de rutas filtradas por Tipo de Servicio...");

    // 1. Verifica si 'usuario.tiposServicios' es un array válido.
    if (!usuario || !Array.isArray(usuario.tipoServicios)) {
      console.warn("⚠️ 'usuario.tiposServicios' no es un array o no existe. Solo se mostrarán rutas públicas.");
      // Devuelve solo las rutas que no requieren un servicio/permiso.
      return routes.filter(route => !route.permission);
    }

    // 2. Muestra los servicios que maneja el usuario.
    const userServices = usuario.tipoServicios;
    console.log("✅ Servicios que maneja el usuario:", userServices);

    const finalRoutes = routes.map(route => {
      console.log(`\nProcessing route: ${route.name}`);

      // 3. Filtra los submenús (si los hubiera) basados en los servicios del usuario.
      const visibleSubmenus = route.submenu?.filter(subItem => {
          const requiredService = subItem.permission;
          // La condición es que no requiera servicio, o que el usuario lo tenga.
          const hasService = userServices.includes(requiredService);
          
          console.log(
            `-- Submenu: '${subItem.name}' | Servicio requerido: '${requiredService}' | ¿Lo tiene?: ${hasService}`
          );
          
          return !requiredService || hasService;
        }) || [];

      console.log(`-> Submenús visibles para '${route.name}':`, visibleSubmenus.map(s => s.name));

      // 4. Determina si la ruta principal es visible.
      const mainRequiredService = route.permission;
      // La condición es la misma: no requiere servicio, o el usuario lo tiene.
      const hasMainService = !mainRequiredService || userServices.includes(mainRequiredService);

      console.log(`-> Ruta principal '${route.name}' | Servicio requerido: '${mainRequiredService}' | ¿Lo tiene?: ${hasMainService}`);
      
      const hasVisibleSubmenus = visibleSubmenus.length > 0;
      const isVisible = hasMainService || hasVisibleSubmenus;

      console.log(`-> ¿Se mostrará '${route.name}'?`, isVisible ? "Sí" : "No");
      
      // 5. Devuelve la ruta si cumple las condiciones.
      if (isVisible) {
        return { ...route, submenu: visibleSubmenus };
      }
      
      return null;
    }).filter(Boolean); // Filtra los nulos que no cumplieron las condiciones.

    // 6. Muestra el resultado final.
    console.log("\n✅✅✅ Rutas finales filtradas:", finalRoutes.map(r => r.name));
    
    return finalRoutes;

  }, [usuario.tiposServicios]); // La dependencia ahora es la lista de servicios.

  // Manejar cambios en el tamaño de la ventana
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Verificar el tamaño inicial
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Función para manejar la navegación
  const handleNavigate = (path) => {
    setActiveRoute(path);
    navigate(path);
  };

  // Función para manejar el cierre de sesión
  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

   //cargar configuracion
  if(loadingConfiguracion){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos de configuracion...</p>
        </div>
      </div>
    );
  }

  if(configuracion === null){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error al cargar datos de configuracion</p>
        </div>
      </div>
    );
  }

  if (loadingUsuario) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Cargando datos del usuario...</p>
        </div>
      </div>
    );
  }

  //error en usuario, notificacion
  if(usuario === null){
    return (
      <div className="flex h-screen w-full items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="inline-block h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
          <p className="mt-4 text-lg font-medium text-gray-700">Error notificar</p>
        </div>
      </div>
    );
  }

  //verificar que solo pueden entrar tutores
  if(usuario.rol !="TUTOR"){
    return <PermisoInsuficiente />;
  }

  //verificar si tutor no esta expulsado
  if(usuario.expulsado){
    return <PermisoInsuficiente />;
  }

  //verificar que tutor no este sancionada , proximamente ...
  if(!usuario.activo){
    return <CuentaInactiva />;
  }

  //pasar
  return (
      <div className="flex flex-col h-screen bg-gray-100" style={{ 
        height: 'calc(var(--vh, 1vh) * 100)' 
      }}>
          <MobileTopBar setCollapsed={setSidebarCollapsed} />
      
          <div className="flex flex-1 overflow-hidden" style={{
            paddingTop: 'env(safe-area-inset-top)'
          }}>
        <Sidebar
          routes={filteredRoutes}
          activeRoute={activeRoute}
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
          onNavigate={handleNavigate}
          onLogout={handleLogout}
        />
        
        <div className={`flex-1 overflow-auto flex flex-col transition-all duration-300 main-container ${sidebarCollapsed ? 'ml-0 md:ml-16' : 'ml-0 md:ml-64'}`}>
          <DesktopTopBar userName={usuario.nombrecompleto} fotoPerfil={usuario.fotoPerfil} />
          
          <div className="flex-1 p-4 md:p-6">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );

};

export default HomeScreenTutor;